import { Spinner } from './Spinner'

export const FullPageSpinner = () => {
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/50 backdrop-blur-sm">
      <Spinner className="size-7.5 text-[#b7b7b7]" />
    </div>
  )
}
